module.exports = __webpack_public_path__ + "media/payment_networks/kucoin-eccf938b.png";